export default __webpack_public_path__ + "static/media/electricFence.2a77014e.jpg";